<template>
  <v-card class="rounded-card card-shadow">
    <v-card-title class="headline font-weight-bold pa-5">
      Meu score
    </v-card-title>
    <v-card-text class="text--primary pa-5">
      <v-row no-gutters>
        <v-col cols="6">
          <v-icon large>
            mdi-gauge
          </v-icon>
          <span class="headline font-weight-bold ml-3">
        <template v-if="fornecedor.score">
          {{ fornecedor.score.score | number('0.0') }}
          <span class="font-weight-medium body-1">
            de 1000
          </span>
        </template>
        <template v-else>
          Sem score
        </template>
      </span>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn small
                 fab
                 depressed
                 class="ml-3"
                 color="primary"
                 link to="/minha-pagina#score">
            <v-icon>mdi-arrow-top-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    fornecedor: Object,
  },
};
</script>
